import PersonaViewPage from "./PersonaViewPage";

export {PersonaViewPage}
export default PersonaViewPage
